export default __webpack_public_path__ + "a54312ac53762a209a3aacdb12c27a31.png";